import {getServiceUserNames} from "../../repositories/adminUserRepository";
import {Autocomplete} from "./Autocomplete";

export default function ({value, setValue, serviceType, disabled}) {
    const fetchItems = async () => {
        return await getServiceUserNames(+serviceType.id);
    }

    if (['SqlServer', 'AspNetUserClaims'].includes(serviceType?.description)) {
        return <Autocomplete
            label="Service User Name"
            value={value}
            onSelect={(item) => setValue(item)}
            placeholder="Enter service user name or id..."
            fetchItems={fetchItems}
        />
    }

    return <Autocomplete
        label="Service User Name"
        value={value}
        onSelect={(item) => setValue(item)}
        placeholder="Enter service user name or id..."
        fetchItems={() => []}
    />
}